import { UserOutlined } from "@ant-design/icons";
import { Input } from "antd";

export default {
  getForm: ({ password, validatePassword, validateRepeat }) => {
    const form = [
      {
        key: "password",
        label: "新密碼",
        rules: [
          {
            required: true,
            message: "請輸入密碼"
          },
          {
            validator: validatePassword
          }
        ],
        child: <Input prefix={<UserOutlined className="gray" />} placeholder="請輸入密碼" />
      }
    ];
    return password
      ? [
          ...form,
          {
            key: "repeatPassword",
            label: "確認新密碼",
            rules: [
              {
                required: true,
                message: "確認新密碼與上述相同"
              },
              {
                validator: validateRepeat
              }
            ],
            child: <Input prefix={<UserOutlined className="gray" />} placeholder="請確認密碼" />
          }
        ]
      : form;
  }
};
